module.exports = __webpack_public_path__ + "assets/autotest0.jpg?934fce7105f9a7840defa0ab88ab9976";